<template>
    <v-app>
        <v-main class="main">

            <!-- Sidebar -->
            <Sidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
                @update:drawerOpen="drawerOpen = $event" />

            <v-container fluid class="main-content pa-4">

                <!-- Header -->
                <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

                <div class="content">

                    <div v-if="loading" class="pa-6">

                        <!-- Title skeleton -->
                        <v-skeleton-loader type="heading" width="300" class="mb-6" />

                        <!-- Grid skeleton -->
                        <v-row>
                            <v-col cols="12" md="12" v-for="n in 6" :key="n">
                                <v-card class="pa-6" rounded="lg">

                                   
                                    <v-skeleton-loader type="text" width="60%" />
                                    <v-skeleton-loader type="text" width="40%" class="mt-2" />

                                    <v-divider class="my-4" />

                                    <v-skeleton-loader type="text" width="80%" />

                                </v-card>
                            </v-col>
                        </v-row>

                    </div>


                    <v-row v-else class="g-4 mt-4 mb-8" dense>

                        <!-- Transactions -->
                        <v-col cols="12" md="12" class="ps-md-3">
                            <div class="column-title mb-6">
                                <h5 class="m-0 text-left">Portfolio</h5>
                                <hr class="title-separator" />
                            </div>
                            <GlobalKyc />

                            <v-card class="outer-card chart-wrapper" style="border-radius: 8px;" flat>
                                <v-card class="pa-3 inner-transaction-card" flat>
                                    <div class="mb-2">
                                        <h5 class="m-0 text-left">Portfolio Overview</h5>
                                    </div>
                                    <v-card class="outer-card" flat>
                                        <v-row dense class="g-2" style="height: 100%; padding: 16px;">

                                            <!-- FULL WIDTH COLUMN -->
                                            <v-col cols="12">

                                                <!-- INNER ROW (THIS FIXES YOUR ISSUE) -->
                                                <v-row dense>

                                                    <!-- LEFT COLUMN -->
                                                    <v-col cols="12" md="6" class="d-flex flex-column">

                                                        <!-- TOP CARD -->
                                                        <v-card class="inner-mini-card mb-3 flex-grow-1" flat>
                                                            <div class="pa-3">
                                                                <div class="text-subtitle-1 font-weight-medium">
                                                                    Portfolio Balance
                                                                </div>
                                                                <div class="text-h4 mt-2">{{
                                                                    formatCurrency(totalPortfolioValue) }}</div>
                                                            </div>
                                                        </v-card>

                                                        <!-- BOTTOM CARD -->
                                                        <v-card class="inner-mini-card flex-grow-1" flat>
                                                            <div class="pa-3 d-flex justify-space-between">
                                                                <div class="text-subtitle-1 font-weight-medium">
                                                                    Active Investments
                                                                    <v-tooltip location="top">
                                                                        <template #activator="{ props }">
                                                                            <v-icon v-bind="props" size="16"
                                                                                class="ms-1">
                                                                                mdi-information-variant-circle
                                                                            </v-icon>
                                                                        </template>

                                                                        <span>{{ tooltipText.completed }}</span>
                                                                    </v-tooltip>
                                                                    <p class="text-h5 mt-2 text-orange">{{
                                                                        activePortfolioCount }}</p>
                                                                </div>

                                                                <div class="text-subtitle-1 font-weight-medium">
                                                                    Completed Investments
                                                                    <v-tooltip location="top">
                                                                        <template #activator="{ props }">
                                                                            <v-icon v-bind="props" size="16"
                                                                                class="ms-1">
                                                                                mdi-information-variant-circle
                                                                            </v-icon>
                                                                        </template>

                                                                        <span>{{ tooltipText.active }}</span>
                                                                    </v-tooltip>
                                                                    <div class="text-h5 mt-2 text-green">{{
                                                                        completedPortfolioCount }}</div>
                                                                </div>
                                                            </div>
                                                        </v-card>

                                                    </v-col>

                                                    <!-- RIGHT COLUMN -->
                                                    <v-col cols="12" md="6" class="d-flex">

                                                        <v-card
                                                            class="inner-card flex-grow-1 d-flex align-center justify-center"
                                                            flat>
                                                            <Doughnut :data="chartData" :options="chartOptions"
                                                                style="max-height: 220px; width: 100%;" />
                                                        </v-card>

                                                    </v-col>

                                                </v-row>

                                            </v-col>

                                        </v-row>
                                    </v-card>

                                    <v-row class="g-4 mt-4 mb-8" dense>

                                        <v-col cols="12" sm="12">
                                            <div class="mb-2">
                                                <h5 class="m-0 text-left">Portfolio Summary</h5>
                                            </div>
                                        </v-col>

                                        <!-- Product Cards -->
                                        <v-col v-for="(portfolios, index) in portfolios" :key="index" cols="12" md="4"
                                            class="pa-2">
                                            <v-card class="product-card pa-6 h-100" flat>

                                                <!-- TOP: Logo + Name -->
                                                <div class="d-flex align-center gap-2 mb-4">
                                                    <img :src="getImage(portfolios.type_image)"
                                                        @error="handleImageError" class="product-image" />
                                                    <div class="text-left">
                                                        <div class="font-weight-bold text-body-1">
                                                            {{ portfolios.product_type_name }}
                                                        </div>

                                                    </div>
                                                </div>

                                                <!-- INNER CARD -->
                                                <v-card class="inner-mini-card pa-2 mb-3" flat>

                                                    <!--top content-->
                                                    <div class="d-flex justify-space-between">
                                                        <!-- LEFT: Maturity -->
                                                        <div class="text-left">
                                                            <div class="text-caption text-grey">Total Invested</div>
                                                            <div class="font-weight-medium">
                                                                {{ formatCurrency(portfolios.total_invested) }}
                                                            </div>
                                                        </div>

                                                        <!-- RIGHT: Rate -->
                                                        <div class="text-right">
                                                            <div class="text-caption text-grey">Total Gained</div>
                                                            <div class="font-weight-medium text-green">
                                                                {{ formatCurrency(portfolios.total_accumulated_yield) }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- DIVIDER -->
                                                    <v-divider class="my-3" />

                                                    <!--bottom content-->
                                                    <div class="d-flex justify-space-between">

                                                        <!-- LEFT -->
                                                        <div class="text-left">
                                                            <div class="text-caption text-grey">Growth</div>
                                                            <div class="font-weight-medium">
                                                                {{
                                                                    formatNumber(((portfolios.total_accumulated_yield)/(portfolios.total_invested))*100)
                                                                }}%
                                                            </div>
                                                        </div>

                                                        <!-- RIGHT -->
                                                        <div class="text-right">
                                                            <div class="text-caption text-grey">Total Gained</div>
                                                            <div class="font-weight-medium text-green">
                                                                {{ formatCurrency(portfolios.total_accumulated_yield +
                                                                portfolios.total_invested) }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </v-card>

                                                <!-- BOTTOM ROW -->
                                                <div class="d-flex mt-auto">
                                                    <div class="ms-auto d-flex align-center gap-2">
                                                        <span
                                                            class="text-caption font-weight-medium text-right clickable-title"
                                                            @click="viewSummary(portfolios.product_type_id)">
                                                            View Portfolio
                                                        </span>
                                                        <v-icon size="16" class="ms-1">mdi-arrow-right-circle</v-icon>
                                                    </div>
                                                </div>

                                            </v-card>
                                        </v-col>

                                    </v-row>
                                </v-card>

                            </v-card>


                        </v-col>
                    </v-row>

                </div>
            </v-container>
        </v-main>
    </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue"
import Sidebar from "@/components/Sidebar.vue"
import Header from "@/components/Header.vue"
import { useRouter } from "vue-router"
import { useTransactStore } from "@/store/transaction"
import { useInvStore } from "@/store/investment"
import { STORAGE_URL } from "@/api/env"
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import avatarImage from '@/assets/crowdital-icon.png'
import GlobalKyc from "@/components/GlobalKyc.vue"

ChartJS.register(ArcElement, Tooltip, Legend)
import { formatCurrency, formatNumber } from "@/util"

const router = useRouter()
//piniastore
const trn = useTransactStore()
const port = useInvStore()

const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)
const loading = ref(true)

//Product type image
const defaultImage = avatarImage

const getImage = (image) => {
    return image ? `${STORAGE_URL}/${image}` : defaultImage
}

const handleImageError = (event) => {
    event.target.src = defaultImage
}

/* Mobile */
const toggleSidebar = () => {
    if (isMobile.value) drawerOpen.value = !drawerOpen.value
    else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
    isMobile.value = window.innerWidth < 768
    drawerOpen.value = !isMobile.value
}

const portfolios = computed(() => port.portfolios?.portfolio_data || [])

const activePortfolioCount = computed(() => port.portfolios?.active_portfolio || 0)
const completedPortfolioCount = computed(() => port.portfolios?.completed_portfolio || 0)

const totalInvested = computed(() => {
    return portfolios.value.reduce((sum, p) => sum + Number(p.total_invested || 0), 0)
})

const totalYield = computed(() => {
    return portfolios.value.reduce((sum, p) => sum + Number(p.total_accumulated_yield || 0), 0)
})

const totalPortfolioValue = computed(() =>
    totalInvested.value + totalYield.value
)

/* Lifecycle */
onMounted(async () => {
    checkMobile()
    window.addEventListener("resize", checkMobile)
    loading.value = true
    await trn.loadTransaction()
    await port.loadPortfolioSummary()
    loading.value = false

})

onUnmounted(() => {
    window.removeEventListener("resize", checkMobile)
})

const baseColors = [
    '#2563eb', // blue
    '#ea580c',  // orange
    '#7c3aed', // purple
    '#f59e0b', // amber
    '#16a34a', // green
    '#0891b2', // cyan
    '#dc2626', // red
]

const generateColors = (count) => {
    //to make the colour dynamic uncomment below
    // return Array.from({ length: count }, () =>
    //     `hsl(${Math.random() * 360}, 70%, 50%)`
    // )

    //static color
    return Array.from({ length: count }, (_, i) => baseColors[i % baseColors.length])
}

const chartData = computed(() => {
    const grouped = {}

    portfolios.value.forEach(item => {
        const type = item.product_type_name || 'Other'
        const amount = item.total_invested + item.total_accumulated_yield
        const total_amount = Number(amount || 0)

        if (!grouped[type]) {
            grouped[type] = 0
        }

        grouped[type] += total_amount
    })

    const labels = Object.keys(grouped)
    const data = Object.values(grouped)

    return {
        labels,
        datasets: [
            {
                data,
                backgroundColor: generateColors(labels.length),
                borderWidth: 0
            }
        ]
    }
})


const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '80%',
    plugins: {
        legend: {
            position: 'right'
        }
    }
}

const tooltipText = {
    growth: "Total growth = (returns / investment) * 100",
    completed: "Investment that is marked completed",
    active: "Currently running investments generating returns",
    invested: "Total amount you have invested",
    returns: "Total profit earned from investments"
}

const viewSummary = (id) => {
    router.push(`/summary/${id}`)
}
</script>

<style scoped>
.main {
    display: flex;
    min-height: 100vh;
}

.main-content {
    flex: 1;
    background: #f8fafc;
}

.content {
    padding-left: 10%;
    padding-right: 10%;
}

/* Card */
.table-card {
    padding: 20px;
    border-radius: 14px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

/* Header */
.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

/* Table */
.modern-table {
    border: none;
}

/* Product */
.product-cell {
    display: flex;
    align-items: center;
    gap: 12px;
}

.product-image {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
}

.product-image {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
    margin-right: 2%;
}

.product-name {
    font-weight: 700;
}

.product-desc {
    font-size: 16px;
    color: #64748b;
}

/* Status */
.status-pill {
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
}

.status-active {
    background: #ecfdf5;
    color: #16a34a;
}

.status-inactive {
    background: #fef2f2;
    color: #dc2626;
}

/* Search input */
.search-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.search-icon {
    position: absolute;
    left: 8px;
    color: #64748b;
}

.search-wrapper input {
    padding-left: 28px;
}

.clickable-title {
    cursor: pointer;
    transition: 0.2s ease;
}

.clickable-title:hover {
    opacity: 0.7;
}

/* Button */
.theme-button {
    height: 46px;
    background: #0f2638;
    color: #fff;
    border-radius: 6px;
    font-weight: 600;
    transition: all 0.25s ease;
}

:deep(.modern-table .p-datatable-thead > tr > th) {
    background: #eef7f0;
    color: #065f46;
    font-weight: 600;
    border-bottom: 2px solid #c1edc3;
}

/* Column title */
.column-title h5 {
    font-size: 1.1rem;
    font-weight: 400;
    margin-bottom: 2.5%;
}

/* Horizontal line below title */
.title-separator {
    border: none;
    height: 1px;
    background-color: #eae5e5;
    margin: 0;
    margin-bottom: 8px;
}

.product-card {
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
}

/* Outer card wrapping the 4 inner cards */
.outer-card {
    border: 1px solid #e4dede;
    border-radius: 8px;
    background: #fff;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px;
}

/* Inner cards */
.inner-card {
    border: 1px solid #eae5e5;
    border-radius: 6px;
    padding: 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.inner-mini-card {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    background: #ffffff;
}

.fill-height {
    height: 100%;
}

.spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}


/* Mobile */
@media (max-width: 600px) {
    .content {
        padding: 0;
    }

    .avatar-mobile {
        width: 32px;
        height: 32px;
    }

    .title-mobile {
        font-size: 0.9rem;
    }

    .icon-mobile {
        font-size: 16px;
    }
}
</style>
